import { render, staticRenderFns } from "./A_nonactivate.vue?vue&type=template&id=595508e8&scoped=true&"
import script from "./A_nonactivate.vue?vue&type=script&lang=js&"
export * from "./A_nonactivate.vue?vue&type=script&lang=js&"
import style0 from "./A_nonactivate.vue?vue&type=style&index=0&id=595508e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595508e8",
  null
  
)

export default component.exports